import { MapPin } from 'lucide-react';
import { getMapEmbedSrc } from '../../utils/mapEmbed.js';

export default function VacacionMapEmbed({ mapaEmbed, ubicacionLabel, className = '' }) {
  const src = getMapEmbedSrc(mapaEmbed);
  if (!src) return null;

  return (
    <div className={className}>
      <h3 className="flex items-center gap-2 font-display text-lg font-semibold text-accent-blue">
        <MapPin className="h-5 w-5 text-accent-lime" aria-hidden />
        Ubicación
      </h3>
      {ubicacionLabel ? <p className="mt-1 text-sm text-slate-500">{ubicacionLabel}</p> : null}
      <div className="mt-4 overflow-hidden rounded-2xl border border-slate-200 bg-slate-50 shadow-sm ring-1 ring-slate-100">
        <div className="aspect-[4/3] w-full min-h-[240px] sm:min-h-[280px]">
          <iframe
            src={src}
            title={ubicacionLabel ? `Mapa: ${ubicacionLabel}` : 'Mapa de la sede vacacional'}
            className="h-full w-full border-0"
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </div>
  );
}
